import Session from 'Faster/model/Session';
import FasterRequest from 'Faster/network/FasterRequest';
import ServerDate from 'Faster/model/ServerDate';

class UpdateSessionRequest implements FasterRequest {
  public readonly method: string = FasterRequest.METHOD_PUT;
  private localTimestamp: Date;
  private ntpLocalTimestamp: Date;
  private session: Session;

  public constructor(session: Session, localTimestamp: Date) {
    this.localTimestamp = localTimestamp;
    this.ntpLocalTimestamp = ServerDate.now();
    this.session = session;
  }

  public body(): object {
    return {
      sessionId: this.session.id,
      userId: this.session.userId,
      geoPoint: this.session.geoPoint,
      sessionProperties: this.session.properties,
      localTimestamp: this.localTimestamp,
      ntpLocalTimestamp: this.ntpLocalTimestamp,
    };
  }

  public headers(): object {
    return {
      'Content-Type': 'application/json',
    };
  }

  public endpoint = (): string => '/v1/session/' + this.session.id;

  public query = (): string => '';
}

export default UpdateSessionRequest;
